import React, { useState, useEffect } from "react"
import ProductForm from "./Product/index"
import ProductList from "./productList"
import Categories from "./Categories"

const ProductsTab = ({ tabIsActive, setSubTabBreadcrumb }) => {
  const TAB_CONTENT = {
    PRODUCT_LIST: 1,
    PRODUCT_FORM: 2,
    CATEGORIES_FORM: 3,
  }

  const [activeContent, setActiveContent] = useState(TAB_CONTENT.PRODUCT_LIST)
  const [selectedCategoryId, setSelectedCategoryId] = useState()

  useEffect(() => {
    setActiveContent(TAB_CONTENT.PRODUCT_LIST)
  }, [tabIsActive])

  useEffect(() => {
    if (activeContent === 1 && tabIsActive) {
      setSubTabBreadcrumb([{ title: "Management" }])
    }
  }, [activeContent])

  return (
    <React.Fragment>
      {activeContent === TAB_CONTENT.PRODUCT_LIST && (
        <ProductList
          handleOpenCategoriesForm={() =>
            setActiveContent(TAB_CONTENT.CATEGORIES_FORM)
          }
          handleOpenProductForm={id => {
            setSelectedCategoryId(id)
            setActiveContent(TAB_CONTENT.PRODUCT_FORM)
          }}
        />
      )}
      {activeContent === TAB_CONTENT.CATEGORIES_FORM && (
        <Categories
          handleBack={() => setActiveContent(TAB_CONTENT.PRODUCT_LIST)}
          setSubTabBreadcrumb={items => {
            setSubTabBreadcrumb([
              {
                title: "Management",
                type: "tab",
                clickHandler: () => {
                  setActiveContent(TAB_CONTENT.PRODUCT_LIST)
                },
              },
              ...items,
            ])
          }}
        />
      )}
      {activeContent === TAB_CONTENT.PRODUCT_FORM && (
        <ProductForm
          handleBack={() => setActiveContent(TAB_CONTENT.PRODUCT_LIST)}
          categoryId={selectedCategoryId}
          setSubTabBreadcrumb={items => {
            setSubTabBreadcrumb([
              {
                title: "Management",
                type: "tab",
                clickHandler: () => {
                  setActiveContent(TAB_CONTENT.PRODUCT_LIST)
                },
              },
              ...items,
            ])
          }}
        />
      )}
    </React.Fragment>
  )
}

export default ProductsTab
